module.exports = __webpack_public_path__ + "static/media/modulo-comercial - Copia.db2d52a1.svg";